import React from "react";
import { Link } from "react-router-dom";

//Pantalla de error visible. Reemplaza al patrón de redirigir en silencio al
//inicio (<Redirect to="/" />) cuando falla la carga de un recurso: le explica
//al vecino qué pudo haber pasado y le ofrece una salida clara. Usa role="alert"
//para que los lectores de pantalla lo anuncien.
const ErrorMensaje = ({
  titulo = "No pudimos cargar esta página",
  mensaje = "Es posible que el enlace sea incorrecto o que haya un problema momentáneo de conexión. Volvé a intentarlo en unos minutos.",
  linkTo = "/",
  linkTexto = "Volver al inicio",
}) => (
  <div
    className="d-flex flex-column align-items-center justify-content-center text-center p-4"
    style={{ minHeight: "60vh" }}
    role="alert"
  >
    <h1 className="h4 ppr-color-azul font-weight-bold">{titulo}</h1>
    <p className="mb-4" style={{ maxWidth: "36rem" }}>
      {mensaje}
    </p>
    <Link to={linkTo} className="btn ppr-btn-verde font-weight-bold">
      {linkTexto}
    </Link>
  </div>
);

export default ErrorMensaje;
